import React, { forwardRef } from 'react';
import styled from 'styled-components';
const ButtonStyleReset = styled.div ``;
const StyleInheritingButton = styled.button `
  all: inherit;
`;
export const StylelessButton = forwardRef((props, ref) => (React.createElement(ButtonStyleReset, null,
    React.createElement(StyleInheritingButton, Object.assign({}, props, { type: "button", ref: ref })))));
